/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classes_TitleInputs */

const da_classes_title = /** @type {(inputs: Classes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasser`)
};

/** @type {(inputs: Classes_TitleInputs) => LocalizedString} */
const en_classes_title = da_classes_title;

/**

* @param {Classes_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const classes_title = /** @type {((inputs?: Classes_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classes_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_classes_title(inputs)
	return /** @type {LocalizedString} */ ("Klasser")
});